export { PartnerSlider } from './PartnerSlider';
